export class ContactsModel{
concode = '' ;
conaname = '' ;
consaklut = '' ;
conspecial = '' ;
conclass = '' ;
conkeyperson = '' ;
conkeytitel = '' ;
conarea = '' ;
conaddress1 = '' ;
conaddress2 = '' ;
contel1 = '' ;
contel2 = '' ;
contel3 = '' ;
conmobile = '' ;
confax = '' ;
conemail = '' ;
conweb = '' ;
conimage : any ;
contype = '' ;
compcode = '1' ;
modifaieddate = '2024-01-01' ;
userid = '' ;
}
